export  const  clearUnderMirror = {
    methods: {
        clearPortData(){
            this.$store.commit("handleUnderMirror", {type: "skin", data: ""});
			this.$store.commit("handleUnderMirror", {type: "general", data: ""});
            this.$store.commit("handleUnderMirror", {type: "ct", data: ""});
            this.$store.commit("handleUnderMirror", {type: "bc", data: ""});
            this.$store.commit("handleUnderMirror", {type: "bl", data: ""});
            this.$store.commit("clearHandleReportByType");
            this.$store.commit("clearchooseItImgArr");
            this.$store.commit("clearchooseItImgArrSkin");
        }
    },
  }
